<template>
	<div :class="['info-tiles', { 'info-tiles--stacked': stacked }]" :style="minWidth ? { '--info-tiles-min': `${minWidth}px` } : null">
		<v-card v-for="tile in tiles" :key="tile.key" :class="['info-tiles__tile', { 'info-tiles__tile--wide': tile.wide }]" flat border>
			<span class="info-tiles__label">
				<v-icon v-if="tile.icon" size="small">{{ tile.icon }}</v-icon>
				{{ tile.label }}
			</span>
			<span :class="['info-tiles__value', { 'info-tiles__value--muted': tile.muted }]">
				<slot :name="`value-${tile.key}`" :tile="tile">{{ tile.display }}</slot>
			</span>
		</v-card>
	</div>
</template>

<script setup>
defineProps({
	tiles: { type: Array, required: true },
	stacked: { type: Boolean, default: false },
	minWidth: { type: Number, default: null },
});
</script>
